import dayjs from 'dayjs';

export default {
  nonExplicitSupportedLngs: true,
  keySeparator: false,
  detection: {
    lookupQuerystring: 'locale'
  },
  interpolation: {
    escapeValue: false,
    format(value, format) {
      if (dayjs.isDayjs(value)) {
        return value.format(format);
      }
      return value;
    }
  },
  react: {
    useSuspense: false
  },
  debug: false,
  ns: [
    'search',
    'cta',
    'checkout',
    'personalDetails',
    'paymentDetails',
    'vehicle',
    'globalError',
    'dates',
    'navigation',
    'login',
    'dateFormat',
    'bookingDetails',
    'booking',
    'listing',
    'profile',
    'countries',
    'bookingsMade',
    'bookingsReceived',
    'resetPassword',
    'homePage',
    'longTermDurationPicker',
    'duration',
    'deleteAccount',
    'termsAndConditions',
    'privacyPolicy',
    'cancellationPolicy',
    'help',
    'payments',
    'dashboard',
    'bookingsMade',
    'footer',
    'cookiePolicy',
    'agreementPolicy',
    'welshHelp',
    'howToPark',
    'searchResultsFilters',
    'listingPageCalendar',
    'listingDetails',
    'trustWidget',
    'monthlyCheckout',
    'bookingPreference'
  ],
  defaultNS: 'cta',
  fallbackLng: (code) => {
    if (!code) {
      return false;
    }

    if (code && code.startsWith('de')) {
      return 'de';
    }

    if (code && code.startsWith('cy')) {
      return 'cy';
    }

    return 'en';
  }
};
